import { useEffect, useState } from "react";
import { artAssets, sagaSpecs } from "../data/site";
import { OrderButton } from "./OrderButton";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const RELEASE_DATE = new Date(2026, 11, 1); // Vol. 1 drops December 01 — local midnight

function useReleaseCountdown() {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(timer);
  }, []);
  const diff = Math.max(0, RELEASE_DATE.getTime() - now);
  return {
    live: diff > 0,
    days: Math.floor(diff / 86400000),
    hours: Math.floor(diff / 3600000) % 24,
    mins: Math.floor(diff / 60000) % 60,
    secs: Math.floor(diff / 1000) % 60,
  };
}

const pad = (value) => String(value).padStart(2, "0");

export function SagaSection() {
  const countdown = useReleaseCountdown();
  return (
    <section id="manga" className="saga-section" data-testid="saga-section">
      <SectionHeading
        eyebrow="01 / THE SAGA BEGINS"
        title="A physical artifact built for the wasteland shelf."
        text="The official cover is live. Vol. 1 drops December 01 — 24 pages, $1.99 for the digital single chapter, $7.00 for the indie print single issue. Bonus character sheets and the concept art list arrive with the remaining volume assets."
      />
      <div className="saga-grid">
        <Reveal className="book-stage" delay={0.1}>
          <div className="book-shadow" />
          <div className="book-spine">DOLO VOL.1</div>
          <div className="book-mockup">
            <img loading="lazy"
              src={artAssets.cover}
              alt="Dolo: Wasteland Runner Vol. 1 official cover art by Terrence J Moore"
              className="book-cover-image"
              data-testid="saga-cover-image"
            />
          </div>
        </Reveal>
        <Reveal className="saga-panel" delay={0.18}>
          <p className="saga-lead">
            Dolo: Wasteland Runner Vol. 1 is staged as a stark, high-impact manga release with its TCG ecosystem wired directly into the archive.
          </p>
          <div className="spec-grid">
            {sagaSpecs.map((spec) => (
              <div className="spec-cell" key={spec.label} data-testid={`spec-${spec.label.toLowerCase().replaceAll(" ", "-")}`}>
                <span>{spec.label}</span>
                <strong>{spec.value}</strong>
              </div>
            ))}
          </div>
          <div className="release-countdown" data-testid="release-countdown">
            {countdown.live ? (
              <>
                <span className="release-countdown-label">VOL. 1 DROPS DEC 01 — T-MINUS</span>
                <div className="release-countdown-grid">
                  {[
                    ["DAYS", countdown.days, "countdown-days"],
                    ["HOURS", pad(countdown.hours), "countdown-hours"],
                    ["MINS", pad(countdown.mins), "countdown-mins"],
                    ["SECS", pad(countdown.secs), "countdown-secs"],
                  ].map(([label, value, testId]) => (
                    <div className="release-countdown-cell" key={label} data-testid={testId}>
                      <strong>{value}</strong>
                      <small>{label}</small>
                    </div>
                  ))}
                </div>
              </>
            ) : (
              <span className="release-countdown-label is-live" data-testid="countdown-live">VOL. 1 OUT NOW — SUPPLY ROUTE OPEN</span>
            )}
          </div>
          <OrderButton testId="saga-order-button">RESERVE ORDER ROUTE</OrderButton>
        </Reveal>
      </div>
    </section>
  );
}
